// src/components/ChangeLocation.jsx

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLocation, fetchLocal } from '../content/local';
import { findCity } from '../utils/location';

export default function ChangeLocation({ currentCity, asTag = false }) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(currentCity || '');
  const dispatch = useDispatch();
  const nav = useNavigate();
  const [activeTag, setActiveTag] = useState('');


  // allow TagBar to open this popup
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener('open-change-location', h);
    return () => window.removeEventListener('open-change-location', h);
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    const match = findCity(value);
    if (!match) return alert('City not found');

    const next = {
      scope: 'city',
      state: match.state,
      county: match.county,
      city: match.name,
      label: match.name,
    };

    dispatch(setLocation(next));
    dispatch(fetchLocal(next));
    nav(`/local/${encodeURIComponent(next.label)}`);
    setOpen(false);
  };

  return (
    <>
      {asTag ? (
        <button className="tag change-location" onClick={() => setOpen(o=>!o)}>Change Location</button>
      ) : (
        <button onClick={() => setOpen(o=>!o)}>Change Location</button>
      )}

      {open && (
        <div className="cl-pop">
          <form onSubmit={onSubmit}>
            <input className="cl-input" value={value} onChange={e=>setValue(e.target.value)} />
            <div className="cl-actions">
              <button type="button" className="cl-btn cl-btn--secondary" onClick={()=>setOpen(false)}>Cancel</button>
              <button type="submit" className="cl-btn cl-btn--primary">Go</button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

